import { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import '../components/Login/Login.css';

export default function VerifyEmailPage() {
  const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
  const [msg, setMsg] = useState('Verifying...');
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setMsg('Missing verification token.');
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/email/verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        if (res.ok) {
          setOk(true);
          setMsg('Email verified! You can log in now.');
        } else {
          setMsg(data.error || 'Verification failed.');
        }
      } catch (e) {
        setMsg('Network error verifying email.');
      }
    })();
  }, [API_URL]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: '#0a0a0a', // Ensuring consistent background
    }}>
      <main className="verify-panel">
        <h1>Email verification</h1>
        <p>{msg}</p>
        <p>
          <a href="/login" className="link-button">{ok ? 'Go to login' : 'Back to login'}</a>
        </p>
      </main>
      <Footer />
    </div>
  );
}
